<template>
  <DialogTemplateToolkit
    :dialog="dialog"
    first_btn="Common.ThankYou"
    :title="$t('Tenders.PriceUpdateRequestSent')"
    without_second_btn
    @apply="close"
    @close="close">
    <template #activator-btn>
      <v-tooltip
        content-class="tooltip white black--text"
        top>
        <template #activator="{ on }">
          <div
            class="flex"
            v-on="!!disabled && typeof disabled == 'string' ? on : ''">
            <sButton
              class="ml-auto send-tender-btn"
              :loading="loading"
              @click="open">
              {{ btn_text }}
            </sButton>
          </div>
        </template>
        {{ typeof disabled == 'string' ? disabled : '' }}
      </v-tooltip>
    </template>
    <template #card-text>
      {{ $t('Tenders.FollowStatusOfRequestInOffersSection') }}
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'sendOfferDifferentPrice',
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  props: {
    disabled: [String, Boolean],
    btn_text: String,
    tenderId: Number,
    rows: Array,
    row: Object,
    checkValidation: Function
  },
  methods: {
    async open() {
      let res = await this.checkValidation()
      if ( res ) {
        this.loading = true
        let rows = {}
        if ( this.row ) {
          rows.rows = [this.row]
        } else {
          rows = this.$_.groupBy( this.rows, 'bidder')
        }

        let promises = Object.values(rows).map(async ( rows ) => {
          return await api.newPriceRequest(this.tenderId, {
            tenderId: this.tenderId,
            rows: rows.map(el => ({
              bidItemId: el.bidItemId ,
              price: el.price,
              comment: el.comment || ''
            }))
          })
            .then(res => {
              if (!res ) {
                throw this.$t('Errors.STHWrong')
              }
              return res
            })
        })
        await Promise.all(promises).then(res => {
          if (res?.every(el => el) ) {
            this.$emit('send')
            this.dialog = true
            this.$root.$emit('tenderUpdate', true)
          }
        })
          .finally(() => {
            this.loading = false
          })
          .catch(error => this.$log_error(error.message))
      }
    },
    close() {
      this.dialog = false
    },
  },
  components: {
    DialogTemplateToolkit
  }
}
</script>
